import { Alert, Button, Stack, Typography } from "@mui/material"
import { skipToken } from "@reduxjs/toolkit/query"
import { Link, useParams } from "react-router-dom"
import { validate as isUuid } from "uuid"
import { PostBotNavigation } from "../components/common/postBotNavigation"
import { OccurrenceDetails } from "../components/occurrences/occurrenceDetails"
import { TemplateQueryFeedback } from "../components/templates/templateQueryFeedback"
import { useGetOccurrenceQuery } from "../services/publications/occurrencesApi"
import { placementHistoryPath } from "../utils/occurrences"

export default function OccurrencePage({
  occurrenceId,
  canRead = true,
}: {
  occurrenceId?: string
  canRead?: boolean
}) {
  const params = useParams()
  const id = occurrenceId ?? params.occurrenceId ?? params.id ?? ""
  const valid = isUuid(id)
  const query = useGetOccurrenceQuery(canRead && valid ? id : skipToken)
  const detail =
    !query.error && query.currentData?.id === id ? query.currentData : undefined
  return (
    <Stack spacing={2} sx={{ width: "100%", minWidth: 0 }}>
      <PostBotNavigation />
      <Typography variant="h4">Отправка {id}</Typography>
      {!canRead ? (
        <Alert severity="warning">Нет доступа к чтению отправки</Alert>
      ) : !valid ? (
        <Alert severity="error">Некорректный ID отправки</Alert>
      ) : (
        <>
          <TemplateQueryFeedback
            query={query}
            empty={!detail && "Запись отправки не найдена"}
          />
          <Button
            disabled={query.isFetching}
            onClick={() => void query.refetch()}
          >
            Обновить результат (GET)
          </Button>
          {detail && (
            <>
              {detail.placementId !== null && detail.purpose !== "preview" && (
                <Button
                  component={Link}
                  to={placementHistoryPath(detail.placementId)}
                >
                  История размещения
                </Button>
              )}
              <OccurrenceDetails occurrence={detail} />
            </>
          )}
        </>
      )}
    </Stack>
  )
}
